var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',_vm._g({class:{
        'add-to-cart': true,
        'add-to-cart--loading': _vm.isLoading,
        'add-to-cart--active': _vm.inCart,
    },attrs:{"disabled":_vm.isLoading || _vm.inCart}},_vm.$listeners),[(_vm.isLoading)?_c('span',{staticClass:"spinner-border spinner-border-sm"}):_vm._e(),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }